// extracted by mini-css-extract-plugin
export default {"container":"ListOfNormalCampaigns_container__fx4Oo"};